import { useEffect, useState } from "react";
import {
    CardElement,
    useStripe,
    useElements,
} from "@stripe/react-stripe-js";
import { useSelector } from "react-redux";
import * as paymentService from "../../../../services/payments";

import "./styles.css";

const AddCard = ({ onReady }) => {
    const stripe = useStripe();
    const elements = useElements();
    const account = useSelector((state) => state.accounts.data);

    const hasCard = !!account.defaultPaymentMethodId;
    const [editingCard, setEditingCard] = useState(!hasCard);
    const [clientSecret, setClientSecret] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchIntent = async () => {
            setLoading(true);
            try {
                const response = await paymentService.getSetupIntent(account.uuid);
                setClientSecret(response.clientSecret);
            } catch (err) {
                console.error(err);
                setError("Erro ao carregar formulário de pagamento.");
            } finally {
                setLoading(false);
            }
        };

        if (editingCard) {
            fetchIntent();
        }
    }, [editingCard, account.uuid]);

    useEffect(() => {
        if (clientSecret && stripe && elements) {
            const cardElement = elements.getElement(CardElement);
            onReady?.({ stripe, cardElement, clientSecret });
        }
    }, [clientSecret, stripe, elements, onReady]);

    if (!editingCard && hasCard) {
        return (
            <div className="card-display-box">
                <div className="card-display-info">
                    <img
                        src={`https://img.icons8.com/color/32/000000/${account.defaultPaymentMethodBrand?.toLowerCase()}.png`}
                        alt="Bandeira do cartão"
                        className="card-brand-icon"
                        onError={(e) => (e.target.style.display = "none")}
                    />
                    <span className="card-brand-label">
                        {account.defaultPaymentMethodBrand?.toUpperCase()} •••• {account.defaultPaymentMethodLast4}
                    </span>
                </div>
                <button className="card-edit-button" onClick={() => setEditingCard(true)}>
                    Usar outro cartão
                </button>
            </div>
        );
    }

    if (loading) return <p>Loading...</p>;
    if (error) return <p style={{ color: "red" }}>{error}</p>;

    return (
        <div>
            <h4 className="card-form-title">Enter your credit card details</h4>
            <div
                style={{
                    padding: 12,
                    border: "1px solid #ccc",
                    borderRadius: 6,
                    backgroundColor: "#fff",
                }}
            >
                <CardElement 
                    options={{ 
                        style: { 
                            base: { 
                                fontSize: "16px" 
                            } 
                        },
                        
                        hidePostalCode: true,
                    }} 
                />
            </div>
        </div>
    );
};

export default AddCard;
